import { render, staticRenderFns } from "./AltenteFreespinsAddForm.vue?vue&type=template&id=890f895a&"
import script from "./AltenteFreespinsAddForm.vue?vue&type=script&lang=js&"
export * from "./AltenteFreespinsAddForm.vue?vue&type=script&lang=js&"
import style0 from "./AltenteFreespinsAddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports